import React from "react";
import ComingSoon from "../../components/ComingSoon";

export default function MissionVision() {
  return <ComingSoon title="Mission & Vision" />;
}
